import { createRouter, createWebHistory, RouterView } from 'vue-router'
import { h } from 'vue'

// Pass-through parent for nested route groups (was `render(c) { return c('router-view') }` in Vue 2)
const RouteShell = { name: 'RouteShell', render: () => h(RouterView) }
import axios from "@/api/http";
import { setSites } from "@/utils/site";
import { isRouteOff, showNotice, MODULE_OFF_NOTICE } from '@/utils/modules'
const OrderList = () => import(/* webpackPrefetch: true */ '../views/orders/OrderList')
const OrderInfo = () => import(/* webpackPrefetch: true */ '../views/orders/OrderInfo')
const Redirect = () => import(/* webpackPrefetch: true */ '../views/redirect/Redirect')
const AddOrder = () => import(/* webpackPrefetch: true */ '@/views/orders/AddOrder')
const CategoryList = () => import(/* webpackPrefetch: true */ '../views/blog/category/CategoryList')
const BrandList = () => import(/* webpackPrefetch: true */ '@/views/products/BrandList')
const ProductBundles = () => import(/* webpackPrefetch: true */ '@/views/products/bundles/ProductBundles')
const ProductBundleItems = () => import(/* webpackPrefetch: true */ '@/views/products/bundles/ProductBundleItems')
const PageList = () => import(/* webpackPrefetch: true */ '@/views/pageList/PageList')
const AddPage = () => import(/* webpackPrefetch: true */ '@/views/pageList/AddPage')
const OffCoupons = () => import(/* webpackPrefetch: true */ '@/views/settings/OffCoupons')
const ProductBundlePrice = () => import(/* webpackPrefetch: true */ '@/views/products/ProductBundlePrice.vue')
const TemplateSettings = () => import(/* webpackPrefetch: true */ '@/views/settings/TemplateSettings')
const CustomerList = () => import(/* webpackPrefetch: true */ '@/views/orders/CustomerList.vue')
const UserCarts = () => import(/* webpackPrefetch: true */ '../views/orders/UserCarts')
const UserStockAlert = () => import(/* webpackPrefetch: true */ '../views/orders/UserStockAlert')
const ReportDate = () => import(/* webpackPrefetch: true */ '@/views/reports/ReportDate.vue')
const ReportProducts = () => import(/* webpackPrefetch: true */ '../views/reports/ReportProducts.vue')
const ReportProductsCardex = () => import(/* webpackPrefetch: true */ '@/views/reports/ReportProductsCardex.vue')
const ReportProvince = () => import(/* webpackPrefetch: true */ '@/views/reports/ReportProvince.vue')
const ReportCity = () => import(/* webpackPrefetch: true */ '@/views/reports/ReportCity.vue')
const ReportPayments = () => import(/* webpackPrefetch: true */ '@/views/reports/ReportPayments.vue')
const OfferBanner = () => import(/* webpackPrefetch: true */ '@/views/offerBanner/OfferBanner.vue')
const SiteFeatures = () => import(/* webpackPrefetch: true */ '@/views/settings/SiteFeatures.vue')
const FloatingContact = () => import(/* webpackPrefetch: true */ '@/views/settings/FloatingContact.vue')
const CachePolicy = () => import(/* webpackPrefetch: true */ '@/views/settings/CachePolicy.vue')
const ImageWebp = () => import(/* webpackPrefetch: true */ '@/views/settings/ImageWebp.vue')
const AiSettings = () => import(/* webpackPrefetch: true */ '@/views/settings/AiSettings.vue')
const AiSettingsTab = () => import(/* webpackPrefetch: true */ '@/views/settings/AiSettingsTab.vue')
const AiUsageTab = () => import(/* webpackPrefetch: true */ '@/views/settings/AiUsageTab.vue')
const AiCampaignsTab = () => import(/* webpackPrefetch: true */ '@/views/settings/AiCampaignsTab.vue')
const AiCampaignsPage = () => import(/* webpackPrefetch: true */ '@/views/blog/news/AiCampaignsPage.vue')
const MessagingSettings = () => import(/* webpackPrefetch: true */ '@/views/settings/MessagingSettings.vue')
const AiLinker = () => import(/* webpackPrefetch: true */ '@/views/tools/AiLinker.vue')
const ShopSettings = () => import(/* webpackPrefetch: true */ '@/views/settings/ShopSettings.vue')
const ThemeContent = () => import('@/views/settings/ThemeContent.vue')
const MontlySaleReport = () => import(/* webpackPrefetch: true */ '@/views/reports/MontlySaleReport.vue')
const IncomeSourceList = () => import(/* webpackPrefetch: true */ '../views/income_source/IncomeSourceList.vue')
const IncomeSourceReport = () => import(/* webpackPrefetch: true */ '../views/income_source/IncomeSourceReport.vue')
const ReportStocks = () => import(/* webpackPrefetch: true */ '../views/reports/ReportStocks.vue')
const Analytics = () => import(/* webpackChunkName: "analytics" */ '@/views/reports/Analytics.vue')
const ProductAdditionalOptionList = () => import(/* webpackPrefetch: true */ '@/views/products/additionalOption/ProductAdditionalOptionList.vue')
const ProductAdditionalOptionValue = () => import(/* webpackPrefetch: true */ '@/views/products/additionalOption/ProductAdditionalOptionValue.vue')
const ProductAdditionalRelation = () => import(/* webpackPrefetch: true */ '@/views/products/additionalOption/ProductAdditionalRelation.vue')
const AddForm = () => import(/* webpackPrefetch: true */ '../views/forms/AddForm.vue')
const FormList = () => import(/* webpackPrefetch: true */ '../views/forms/FormList.vue')
const PopupList = () => import('../views/popups/PopupList.vue')
const PopupEdit = () => import('../views/popups/PopupEdit.vue')
// Authorization header: added per request by src/api/http.js

// Containers
const TheContainer = () => import(/* webpackPrefetch: true */ '@/containers/TheContainer')

// Views
const Dashboard = () => import(/* webpackPrefetch: true */ '@/views/Dashboard');
const PermissionGroup = () => import(/* webpackPrefetch: true */ '@/views/permissions/PermissionGroups');
const AdminList = () => import(/* webpackPrefetch: true */ '@/views/users/AdminList');
const UserList = () => import(/* webpackPrefetch: true */ '@/views/users/UserList');

const UserProfile = () => import(/* webpackPrefetch: true */ '@/views/users/UserProfile');

const Sliders = () => import(/* webpackPrefetch: true */ '@/views/slider/Sliders');
const SliderImages = () => import(/* webpackPrefetch: true */ '@/views/slider/SliderImages');

const Menus = () => import(/* webpackPrefetch: true */ '@/views/menus/Menus');


const AddNews = () => import(/* webpackPrefetch: true */ '@/views/blog/news/AddNews');


const TagsList = () => import(/* webpackPrefetch: true */ '@/views/tags/TagsList');

const CommentsList = () => import(/* webpackPrefetch: true */ '@/views/comments/CommentsList');

//Products
const AddProduct = () => import(/* webpackPrefetch: true */ '@/views/products/AddProduct');
const DigikalaBulkImport = () => import(/* webpackPrefetch: true */ '@/views/products/DigikalaBulkImport');
const MediaLibrary = () => import(/* webpackPrefetch: true */ '@/views/media/MediaLibrary.vue');
const ProductTagsList = () => import(/* webpackPrefetch: true */ '@/views/products/ProductTagsList');

const ProductCommentsList = () => import(/* webpackPrefetch: true */ '@/views/products/ProductCommentsList');
const ProductList = () => import(/* webpackPrefetch: true */ '@/views/products/ProductList');
const ProductCategoryList = () => import(/* webpackPrefetch: true */ '@/views/products/ProductCategoryList');

const ProductPropertyTemplateList = () => import(/* webpackPrefetch: true */ '@/views/products/properties/ProductPropertyTemplateList');
const ProductPropertyTemplateGroupList = () => import(/* webpackPrefetch: true */ '@/views/products/properties/ProductPropertyTemplateGroupList');
const ProductPropertyTemplateGroupItemList = () => import(/* webpackPrefetch: true */ '@/views/products/properties/ProductPropertyTemplateGroupItemsList');



// Views - Notifications
const Settings = () => import(/* webpackPrefetch: true */ '@/views/settings/Settings');
const HomepageBuilder = () => import(/* webpackPrefetch: true */ '@/views/settings/HomepageBuilder');

// Views - Pages
const Page404 = () => import(/* webpackPrefetch: true */ '@/views/pages/Page404');
const Page500 = () => import(/* webpackPrefetch: true */ '@/views/pages/Page500');
const Login = () => import(/* webpackPrefetch: true */ '@/views/pages/Login');
const Register = () => import(/* webpackPrefetch: true */ '@/views/pages/Register');

// Users
const EditNews = () => import(/* webpackPrefetch: true */ '@/views/blog/news/AddNews');
const NewsList = () => import(/* webpackPrefetch: true */ '@/views/blog/news/NewsList');

let router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    linkActiveClass: 'active',
    scrollBehavior: (to, from, saved) => (saved ? saved : {left: 0, top: 0}),
    routes: configRoutes(),
});
// Reset CoreUI inner scroll containers on every navigation
router.afterEach((to, from) => {
  if (to.fullPath === from.fullPath) return
  if (typeof window === 'undefined') return
  window.requestAnimationFrame(() => {
    document.querySelectorAll('.c-body, .c-main, .c-wrapper').forEach((el) => { el.scrollTop = 0 })
  })
})
export default router

// per-site feature toggles: a switched-off section opened directly -> dashboard + notice
router.beforeEach((to, from, next) => {
    let authed = false
    try { authed = !!localStorage.getItem('token') } catch (e) { authed = false }
    if (authed && isRouteOff(to.path)) {
        setTimeout(() => showNotice(MODULE_OFF_NOTICE), 300)
        return next({ path: '/dashboard' })
    }
    return next()
})

router.beforeEach((to, from, next) => {
    console.log("before each" + " token is " + localStorage.getItem('token'));
    // console.log("before each"+next);
    if (to.path == '/') {
        //  window.location.href = '/home';
    }

    // document.body.scro
if(from.meta.saveScroll){
    console.log("path has save scroll")
    localStorage.setItem("scroll"+window.location.path,window.pageYOffset.toString())
}
    if (to.matched.some(record => record.meta.requiresAuth)) {
        console.log("validate requiresAuth");

        if (localStorage.getItem('token') == null || localStorage.getItem('token') == '') {
            console.log("validate is null");

            next({
                path: '/dashboard/login'
            })
        } else {
             validate_user(next, to);


            // let user = JSON.parse(localStorage.getItem('user'))
            // if(to.matched.some(record => record.meta.is_admin)) {
            //     if(user.is_admin == 1){
            //         next()
            //     }
            //     else{
            //         next({ name: 'userboard'})
            //     }
            // }else {
            //     next()
            // }
        }
    } else if (to.matched.some(record => record.meta.guest)) {
        // if(localStorage.getItem('jwt') == null){
        next()
        // }
        // else{
        //     next({ name: 'userboard'})
        // }
    } else {
        next()
    }
});

// Vue Router 4 drops an earlier route when a later one reuses its name, so repeated names get a -N suffix
function configRoutes() {
    return [
        {
            path: '/',
            redirect: '/dashboard',

            name: 'Root',
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/dashboard',
            // redirect: '/dashboard',
            name: 'خانه',
            meta: {
                requiresAuth: true
            },
            component: TheContainer,
            children: [
                {
                    // Vue Router 3 treated this '/' child as the /dashboard index; v4 needs ''.
                    path: '',
                    name: 'پنل مدیریت',
                    component: Dashboard,
                    meta: {
                        requiresAuth: true,
                    }
                },

                {
                    path: 'users',
                    name: 'کاربران',
                    props: true,
                    component: RouteShell,
                    meta: {
                        requiresAuth: true,
                    },
                    children:[
                        {
                            path: 'permission-groups',
                            name: 'گروه های دسترسی',
                            props: true,
                            component: PermissionGroup,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "permission_groups"
                            }
                        },
                        {
                            path: 'admins',
                            name: 'مدیران',
                            props: true,
                            component: UserList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "admins"
                            }
                        }, {
                            path: 'customers',
                            name: 'کاربران-2',
                            props: true,
                            component: UserList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "admins"
                            }
                        },
                        {
                            path: 'profile',
                            name: 'پروفایل',
                            props: true,
                            component: UserProfile,
                            meta: {
                                requiresAuth: true,

                            }
                        },
                    ]
                },

                //*************************************************
                {
                    path: 'products',
                    name: 'محصولات',
                    props: true,
                    component: RouteShell,
                    meta: {
                        requiresAuth: true,
                    },
                    children:[
                        {
                            path: 'list',
                            name: 'لیست محصولات',
                            props: true,
                            component: ProductList,
                            meta: {
                                saveScroll: true,
                                requiresAuth: true,
                                requiresRole: "add_product"
                            }
                        },{
                            path: 'list/:cat_id',
                            name: 'لیست محصولات-2',
                            props: true,
                            component: ProductList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_product"
                            }
                        },

                        {
                            path: 'digikala-bulk',
                            name: 'انتشار گروهی از دیجی‌کالا',
                            props: true,
                            component: DigikalaBulkImport,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_product"
                            }
                        },
                        {
                            path: 'create',
                            name: 'افزودن محصول',
                            props: true,
                            component: AddProduct,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_product"
                            }
                        }, {
                            path: 'edit/:product_id',
                            name: 'ویرایش محصول',
                            props: true,
                            component: AddProduct,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_product"
                            }
                        }, {
                            path: 'clone/:clone_product_id',
                            name: 'ثبت محصول',
                            props: true,
                            component: AddProduct,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_product"
                            }
                        }, {
                            path: 'bundle_price/:product_id',
                            name: 'قیمت خصوصیتی',
                            props: true,
                            component: ProductBundlePrice,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_product"
                            }
                        }, {
                            path: 'category/:cat_id',
                            name: 'دسته بندی کالا ها',
                            props: true,
                            component: ProductCategoryList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "product_category"
                            }
                        }, {
                            path: 'tags',
                            name: 'برچسب محصولات',
                            props: true,
                            component: ProductTagsList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "product_tags"
                            }
                        },{
                            path: 'comments',
                            name: 'دیدگاه محصولات',
                            props: true,
                            component: ProductCommentsList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "product_comments"
                            }
                        },{
                            path: 'comments/:product_id',
                            name: 'دیدگاه محصول',
                            props: true,
                            component: ProductCommentsList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "product_comments"
                            }
                        },{
                            path: 'property-templates',
                            name: 'الگو ویژگی محصولات',
                            props: true,
                            component: ProductPropertyTemplateList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "template_property"
                            }
                        },{
                            path: 'property-groups/:temp_id',
                            name: 'گروه ویژگی محصولات',
                            props: true,
                            component: ProductPropertyTemplateGroupList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "template_property"
                            }
                        },{
                            path: 'property-items/:group_id',
                            name: 'ایتم ویژگی محصولات',
                            props: true,
                            component: ProductPropertyTemplateGroupItemList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "template_property"
                            }
                        },{
                            path: 'product-bundles',
                            name: 'خصوصیات محصولات',
                            props: true,
                            component: ProductBundles,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "product_bundles"
                            }
                        },{
                            path: 'bundle-items/:bundle_id',
                            name: 'مقادیر خصوصیت',
                            props: true,
                            component: ProductBundleItems,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "product_bundles"
                            }
                        },{
                            path: 'brands',
                            name: 'برند',
                            props: true,
                            component: BrandList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "product_brands"
                            }
                        },{
                            path: 'additional-options',
                            name: 'ویژگی اضافی',
                            props: true,
                            component: ProductAdditionalOptionList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "template_property"
                            }
                        },{
                            path: 'additional-options-values/:id',
                            name: 'ویژگی اضافی-2',
                            props: true,
                            component: ProductAdditionalOptionValue,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "template_property"
                            }
                        },{
                            path: 'additional-relation/:id',
                            name: 'ویژگی اضافی-3',
                            props: true,
                            component: ProductAdditionalRelation,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "template_property"
                            }
                        },
                    ]
                },

                //*************************************************
                //*************************************************
                //*************************************************
                //*************************************************

                {
                    path: 'news',
                    name: 'نوشته',
                    props: true,
                    component: RouteShell,
                    meta: {
                        requiresAuth: true,
                    },
                    children:[
                        {
                            path: 'categories/:cat_id',
                            name: 'دسته بندی',
                            props: true,
                            component: CategoryList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "blog_category"

                            }
                        },
                        {
                            path: 'add-news',
                            name: 'افزودن نوشته',
                            props: true,
                            component: AddNews,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "blog_post"
                            }
                        },{
                            path: 'edit-news/:post_id',
                            name: 'ویرایش نوشته',
                            props: true,
                            component: EditNews,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "blog_post"
                            }
                        }, {
                            // The API chat links posts as /dashboard/news/edit/:id
                            path: 'edit/:post_id',
                            redirect: (to) => ({ path: `/dashboard/news/edit-news/${to.params.post_id}` })
}, {
                            path: 'all-news',
                            name: 'همه نوشته ها',
                            props: true,
                            component: NewsList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "blog_post"
                            }
                        }, {
                            path: 'campaigns',
                            name: 'کمپین‌های محتوا',
                            component: AiCampaignsPage,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "blog_post"
                            }
                        }, {
                            path: 'tags',
                            name: 'برچسب ها',
                            props: true,
                            component: TagsList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "blog_tags"
                            }
                        }, {
                            path: 'comments',
                            name: 'دیدگاه ها',
                            props: true,
                            component: CommentsList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "blog_comments"
                            }
                        },
                    ]
                },
                //****************************************
                {
                    path: '/dashboard/display',
                    name: 'نمایش',
                    props: true,
                    component: RouteShell,

                    meta: {
                        requiresAuth: true,
                    },
                    children:[

                        {
                            path: 'template_settings',
                            name: 'تنظیمات قالب',
                            props: true,
                            component: TemplateSettings,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "template_settings"
                            }
                        }, {
                            path: 'sliders',
                            name: 'اسلایدر',
                            props: true,
                            component: Sliders,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "ui_slider"
                            }
                        },
                        {
                            path: 'slider-images/:slider_id',
                            name: 'تصاویر اسلایدر',
                            props: true,
                            component: SliderImages,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "ui_slider"
                            }
                        },
                         {
                            path: 'menus/:menu_id',
                            name: 'منو',
                            props: true,
                            component: Menus,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "ui_menu"
                            }
                        },
                         {
                            path: 'offer-banner',
                            name: 'بنر',
                            props: true,
                            component: OfferBanner,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "ui_menu"
                            }
                        },
                        {
                            path: 'features',
                            name: 'امکانات سایت',
                            component: SiteFeatures,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "ui_settings"
                            }
                        },
                        {
                            path: 'floating-contact',
                            name: 'دکمه تماس شناور',
                            component: FloatingContact,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "ui_settings"
                            }
                        },
                        {
                            path: 'cache',
                            name: 'تنظیمات کش',
                            component: CachePolicy,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "ui_settings"
                            }
                        },
                        {
                            path: 'theme-content',
                            name: 'محتوای قالب',
                            component: ThemeContent,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "ui_settings"
                            }
                        },
                    ]
                },
                //****************************************
                {
                    path: '/dashboard/settings',
                    name: 'تنظیمات',
                    props: true,
                    component: RouteShell,

                    meta: {
                        requiresAuth: true,
                        requiresRole: "ui_settings"
                    },
                    children:[
                        {
                            path: 'image-webp',
                            name: 'بهینه‌سازی عکس‌ها',
                            component: ImageWebp,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "ui_settings"
                            }
                        },

                        {
                            path: 'redirect',
                            name: 'ریدایرکت',
                            props: true,
                            component: Redirect,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "redirect"
                            }
                        },
                        {
                            path: 'shipping',
                            redirect: { path: '/dashboard/settings/shop', query: { tab: 'shipping' } },
                        },
                        {
                            path: 'gateways',
                            redirect: { path: '/dashboard/settings/shop', query: { tab: 'gateways' } },
                        },
                        {
                            path: 'order_status',
                            redirect: { path: '/dashboard/settings/shop', query: { tab: 'order_status' } },
                        },
                        {
                            path: 'shop',
                            name: 'تنظیمات فروشگاه',
                            component: ShopSettings,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'income_source_list',
                            name: 'سورس های ورودی',
                            props: true,
                            component: IncomeSourceList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "redirect"
                            }
                        },
                        {
                            path: 'income-source-report/:id',
                            name: 'گزارش سورس ورودی',
                            props: true,
                            component: IncomeSourceReport,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "redirect"
                            }
                        },
                        {
                            path: 'off_coupons',
                            name: 'کدهای تخفیف',
                            props: true,
                            component: OffCoupons,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "off_coupons"
                            }
                        },
                        {
                            path: 'messaging',
                            name: 'پیامک و بله',
                            component: MessagingSettings,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "basic_settings"
                            }
                        },
                        {
                            path: 'ai',
                            component: AiSettings,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "basic_settings"
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'هوش مصنوعی',
                                    component: AiSettingsTab,
                                },
                                {
                                    path: 'usage',
                                    name: 'گزارش مصرف هوش مصنوعی',
                                    component: AiUsageTab,
                                },
                                {
                                    path: 'campaigns',
                                    name: 'کمپین‌های محتوا هوش مصنوعی',
                                    component: AiCampaignsTab,
                                },
                            ],
                        },
                        {
                            path: 'ai-linker',
                            name: 'هوش مصنوعی لینک‌ساز',
                            component: AiLinker,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "ui_settings"
                            }
                        },
                        {
                            path: 'main-setting',
                            name: 'تنظیمات کلی',
                            props: true,
                            component: Settings,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "basic_settings"
                            }
                        },
                        {
                            path: 'homepage',
                            name: 'صفحه اصلی',
                            component: HomepageBuilder,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "ui_settings"
                            }
                        },
                    ]
                },
                //******************************************
                //*************************************************
                {
                    path: 'orders',
                    name: 'سفارشات',
                    props: true,
                    component: RouteShell,
                    meta: {
                        requiresAuth: true,
                    },
                    children:[
                        {
                            path: 'list',
                            name: 'لیست سفارشات',
                            props: true,
                            component: OrderList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "order_list"
                            }
                        },
                        {
                            path: 'list/:customer_id',
                            name: 'لیست سفارشات-2',
                            props: true,
                            component: OrderList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "order_list"
                            }
                        }, {
                            path: 'info/:order_id',
                            name: 'اطلاعات سفارش',
                            props: true,
                            component: OrderInfo,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "order_list"
                            }
                        }, {
                            path: 'add-order',
                            name: 'افزودن سفارش',
                            props: true,
                            component: AddOrder,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_order"
                            }
                        }, {
                            path: 'edit-order/:order_id',
                            name: 'ویرایش سفارش',
                            props: true,
                            component: AddOrder,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_order"
                            }
                        },{
                            path: 'customers',
                            name: 'لیست مشتریان',
                            props: true,
                            component: CustomerList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_order"
                            }
                        },{
                            path: 'user_carts',
                            name: 'سبد های خرید رها شده',
                            props: true,
                            component: UserCarts,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_order"
                            }
                        },{
                            path: 'user_stock_alert',
                            name: 'اطلاع از موجودی',
                            props: true,
                            component: UserStockAlert,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_order"
                            }
                        },

                    ]
                },

                //*************************************************
                {
                    path: 'pages',
                    name: 'صفحات',
                    props: true,
                    component: RouteShell,
                    meta: {
                        requiresAuth: true,
                    },
                    children:[
                        {
                            path: 'list',
                            name: 'لیست صفحات',
                            props: true,
                            component: PageList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_page"
                            }
                        },{
                            path: 'add',
                            name: 'افزودن صفحه',
                            props: true,
                            component: AddPage,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_page"
                            }
                        },
                        {
                            path: 'edit/:post_id',
                            name: 'ویرایش صفحه',
                            props: true,
                            component: AddPage,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_page"
                            }
                        },

                    ]
                },
   //*************************************************
                {
                    path: 'popups',
                    name: 'پاپ‌آپ‌ها',
                    component: RouteShell,
                    meta: { requiresAuth: true },
                    children: [
                        { path: 'list', name: 'لیست پاپ‌آپ‌ها', component: PopupList, meta: { requiresAuth: true, requiresRole: 'ui_settings' } },
                        { path: 'add', name: 'افزودن پاپ‌آپ', props: true, component: PopupEdit, meta: { requiresAuth: true, requiresRole: 'ui_settings' } },
                        { path: 'edit/:post_id', name: 'ویرایش پاپ‌آپ', props: true, component: PopupEdit, meta: { requiresAuth: true, requiresRole: 'ui_settings' } },
                    ]
                },
                {
                    path: 'forms',
                    name: 'فرم ها',
                    props: true,
                    component: RouteShell,
                    meta: {
                        requiresAuth: true,
                    },
                    children:[
                        {
                            path: 'list',
                            name: 'لیست فرم',
                            props: true,
                            component: FormList,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_page"
                            }
                        },{
                            path: 'add',
                            name: 'افزودن فرم',
                            props: true,
                            component: AddForm,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_page"
                            }
                        },
                        {
                            path: 'edit/:post_id',
                            name: 'ویرایش فرم',
                            props: true,
                            component: AddForm,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_page"
                            }
                        },
                        {
                            path: 'edit/:post_id',
                            name: 'فرم ثبت شده',
                            props: true,
                            component: AddPage,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_page"
                            }
                        },

                    ]
                },
                //*************************************************

   //*************************************************

   //*************************************************
                {
                    path: 'media',
                    name: 'کتابخانه رسانه',
                    component: MediaLibrary,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: 'reports',
                    name: 'گزارشات',
                    props: true,
                    component: RouteShell,
                    meta: {
                        requiresAuth: true,
                    },
                    children:[
                        {
                            path: 'analytics',
                            name: 'آمار بازدید',
                            component: Analytics,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_page"
                            }
                        },
                        {
                            path: 'report-date',
                            name: 'گزارش بازه زمانی',
                            props: true,
                            component: ReportDate,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_page"
                            }
                        }, {
                            path: 'province',
                            name: 'گزارش استان ها',
                            props: true,
                            component: ReportProvince,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_page"
                            }
                        }, {
                            path: 'cities/:province_id',
                            name: 'گزارش شهر ها',
                            props: true,
                            component: ReportCity,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_page"
                            }
                        }, {
                            path: 'products',
                            name: 'گزارش کالا ها',
                            props: true,
                            component: ReportProducts,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_page"
                            }
                        }, {
                            path: 'stocks',
                            name: 'گزارش موجودی',
                            props: true,
                            component: ReportStocks,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_page"
                            }
                        }, {
                            path: 'monthly_sale_products',
                            name: 'گزارش فروش ماهانه',
                            props: true,
                            component: MontlySaleReport,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_page"
                            }
                        }, {
                            path: 'products/:id',
                            name: 'گزارش کالا ها-2',
                            props: true,
                            component: ReportProductsCardex,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_page"
                            }
                        }, {
                            path: 'payments',
                            name: 'گزارش پرداختی',
                            props: true,
                            component: ReportPayments,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "add_page"
                            }
                        },
                    ]
                },


            ]
        },
        {
            path: '/dashboard/404',
            name: 'Page404',
            component: Page404
        },
        {
            path: '/dashboard/500',
            name: 'Page500',
            component: Page500
        },
        {
            path: '/dashboard/login',
            name: 'Login',
            component: Login
        },

        {
            path: '/register',
            name: 'Register',
            component: Register
        }
    ]
}

// Token validation is cached (5 min) so route changes render immediately; it is refreshed in the
// background and an expired token is still caught by the 401 handler in src/api/http.js.
const VALIDATE_TTL = 5 * 60 * 1000
let validatedAt = 0
let validating = null
function cachedPermissions() {
    try { return JSON.parse(localStorage.getItem('permissions') || 'null') } catch (e) { return null }
}
function routeAllowed(to, permissions) {
    const role = to.matched.map((r) => r.meta && r.meta.requiresRole).filter(Boolean).pop()
    return !role || (Array.isArray(permissions) && permissions.includes(role))
}
function validate_user(next, to) {
    const perms = cachedPermissions()
    if (perms && validatedAt && Date.now() - validatedAt < VALIDATE_TTL) {
        return routeAllowed(to, perms) ? next() : next({ path: '/dashboard/404' })
    }
    if (perms && validatedAt) {
        // stale: let the page render now, revalidate in the background
        revalidate()
        return routeAllowed(to, perms) ? next() : next({ path: '/dashboard/404' })
    }
    return validate_user_network(next, to)
}
function revalidate() {
    if (validating) return validating
    const formData = new FormData()
    formData.append('token', localStorage.getItem('token'))
    validating = axios.post('/api/admin/user/validate-token', formData, { show_pros: false }).then((res) => {
        if (res.data && res.data.validate) {
            localStorage.setItem('permissions', JSON.stringify(res.data.permissions))
            if (Array.isArray(res.data.sites)) setSites(res.data.sites); if (res.data.user_name) { localStorage.setItem('user_name', res.data.user_name); window.dispatchEvent(new Event('panel-user')) }
            validatedAt = Date.now()
        } else {
            validatedAt = 0
            localStorage.removeItem('token')
            window.location.assign('/dashboard/login?redirect=' + encodeURIComponent(window.location.pathname + window.location.search))
        }
    }).catch(() => {}).finally(() => { validating = null })
    return validating
}
function validate_user_network(next, to) {
    const formData = new FormData()
    let url;
    url = "/api/admin/user/validate-token";

    formData.append('token', localStorage.getItem('token'))

    axios.post(url, formData,{}).then((res) => {
        console.log("validate token is " + res.data);


        if (res.data.validate) {
            localStorage.setItem("permissions",JSON.stringify(res.data.permissions))
            if (Array.isArray(res.data.sites)) setSites(res.data.sites); if (res.data.user_name) { localStorage.setItem('user_name', res.data.user_name); window.dispatchEvent(new Event('panel-user')) }
            validatedAt = Date.now()
            console.log("validate is true");
            let meta_role = to.meta.requiresRole;
            // console.log("user name is "+ this.user_permissions.includes("edit_settings"));
            if (meta_role == null) {
                console.log("requiresRole is null");
                next();

            } else {
                console.log("requiresRole is " + meta_role);
                let permissions = res.data.permissions;
                if (permissions.includes(meta_role)) {
                    console.log("user has permissions ");
                    next();

                } else {
                    next({
                        path: '/dashboard/404'
                    });
                }

            }

        } else {
            console.log("validate is false");

            next({
                path: '/dashboard/login',
            })
        }
        // return res.data;
    }).catch(function (error) {
            next({
                path: '/dashboard/login',
            })
            console.log(error);
        });

}

